import {
	Dispatch,
	RefObject,
	SetStateAction,
	useCallback,
	useRef
} from "react";

export function useSetStateAction<T extends {}>(
	value: T,
	callback: Dispatch<T>
): Dispatch<SetStateAction<T>> {
	if (typeof value === "function") {
		throw new Error("Value cannot be a function");
	}

	const valueRef: RefObject<T> = useRef<T>(null!);
	valueRef.current = value;

	return useCallback(
		(x: SetStateAction<T>): void => {
			if (typeof x === "function") {
				const typedX = x as ((prevState: T) => T);
				valueRef.current = typedX(valueRef.current);
			} else {
				valueRef.current = x;
			}
			callback(valueRef.current);
		},
		[callback]
	);
}